import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getTrends} from './getTrends';

export const dashboardTrendsQueryOptions = (months = 6) =>
  queryOptions({
    queryKey: keys.dashboard.trends(months),
    queryFn: () => getTrends(months),
    staleTime: 120_000,
  });
